import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ContextState } from './context.state';

const selectContextFeatureState = createFeatureSelector<ContextState>('context');
export const selectMultipleContextProperties = createSelector(
    selectContextFeatureState,
    state => state.multipleProperties
);

// The single-property context (set by app.effects.ts onStartup$ for Property+Mixed
// spaces to currentSpace.id = the property UUID). Mirrors the AngularJS ng-redux
// `ui.context.singleProperty` (both set from the same currentSpace.id at boot).
export const selectSingleProperty = createSelector(
    selectContextFeatureState,
    state => state.singleProperty
);

export const selectContextDetails = createSelector(
    selectContextFeatureState,
    state => state.details
);

export const selectContextCsm = createSelector(
    selectContextDetails,
    state => state.csm
);
